import React from 'react';
import PropTypes from 'prop-types';
import { Rectangle } from 'recharts';

export const CLR_MARK_COLOR = '#26735C';
export const CLR_MARK_HOVER_COLOR = '#2E8B6F';

/** Same step as #26735C → #2E8B6F: each channel is about 21% lighter. */
const HOVER_LIGHTEN = 1.21;

export function clrHoverColor(color) {
  if (typeof color !== 'string') return color;
  const match = /^#([0-9a-fA-F]{6})$/.exec(color.trim());
  if (!match) return color;
  const channels = [0, 2, 4].map((start) => {
    const channel = parseInt(match[1].slice(start, start + 2), 16);
    return Math.min(255, Math.round(channel * HOVER_LIGHTEN));
  });
  return `#${channels.map((channel) => channel.toString(16).padStart(2, '0')).join('')}`;
}

/** Hovered CLR bar lightens its own color. Transparent pad bars stay transparent. */
export function ClrBarHover(props) {
  if (props.fill === 'transparent' || props.payload?.__pad) {
    return <Rectangle {...props} />;
  }
  return <Rectangle {...props} fill={clrHoverColor(props.fill)} />;
}

ClrBarHover.propTypes = {
  fill: PropTypes.string,
  payload: PropTypes.object,
};
